//@ts-ignore
import Swiper, { Navigation, Pagination } from "swiper";
//@ts-ignore
import SwiperClass from "swiper/types/swiper-class";

const mql = window.matchMedia("(min-width: 1024px)");

const selectors: Record<"block" | "slider", string> = {
  block: "[data-st-louis-shop]",
  slider: "[data-st-louis-shop-slider]",
};

const init = () => {
  Array.from(document.querySelectorAll(selectors.block), (block) => {
    const slider = block.querySelector(selectors.slider) as HTMLElement | null;

    if (!slider) return;

    let instance: SwiperClass = null;

    if (!mql.matches) {
      instance = enableSlider(slider);
    }

    mql.addEventListener("change", ({ matches }: { matches: boolean }) => {
      if (matches) {
        instance.destroy(true, true);
        return;
      }

      instance = enableSlider(slider);
    });
  });
};

const enableSlider = (slider: HTMLElement) => {
  Swiper.use([Navigation, Pagination]);

  return new Swiper(slider, {
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: false,

    pagination: {
      el: "[data-swiper-pagination]",
      clickable: true,
      bulletActiveClass: "active",
      bulletClass: "bullet",
    },
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
